import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	POST_DEVICE_ORDER_DETAIL_ORDERS_API
} from "@apis/apiPath";

const useDeviceOrderDetailApi = () => {
	const Ajax = useAjax();

	// 申請下拉選單
	const postDeviceOrderDetailOrderApi = useCallback(
		async (params) => {
			const { memberID, ...other } = params || {};
			return await Ajax.post(POST_DEVICE_ORDER_DETAIL_ORDERS_API(memberID), other);
		},
		// eslint-disable-next-line
		[]
	);

	return {
		postDeviceOrderDetailOrderApi
	};
};

export default useDeviceOrderDetailApi;
